// 机场头部状态信息
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Card, Tooltip, theme, Row, Col, message } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'

import fhgd from "@/common/img/command_flight/head/fhgd.svg" //返航高度
import xy from "@/common/img/command_flight/head/xy.svg" //小雨
import zy from "@/common/img/command_flight/head/zy.svg" //中雨
import dy from "@/common/img/command_flight/head/dy.svg" //大雨
import fs from "@/common/img/command_flight/head/fs.svg" //风速
import wd from "@/common/img/command_flight/head/wd.svg" //温度
import sd from "@/common/img/command_flight/head/sd.svg" //湿度

import Ethernet from "@/common/img/command_flight/head/Ethernet.svg" //以太网
import cell0 from "@/common/img/command_flight/head/cell0.svg" //4G信号 [0,15)
import cell15 from "@/common/img/command_flight/head/cell15.svg" //4G信号 [15,35)
import cell35 from "@/common/img/command_flight/head/cell35.svg" //4G信号 [35,55)
import cell55 from "@/common/img/command_flight/head/cell55.svg" //4G信号 [55,75)
import cell75 from "@/common/img/command_flight/head/cell75.svg" //4G信号 [75,95)
import cell95 from "@/common/img/command_flight/head/cell95.svg" //4G信号 [95,100)

import dl0 from "@/common/img/command_flight/head/dl0.svg" //电量 [0,25)
import dl25 from "@/common/img/command_flight/head/dl25.svg" //电量 [25,50)
import dl50 from "@/common/img/command_flight/head/dl50.svg" //电量 [50,75)
import dl75 from "@/common/img/command_flight/head/dl75.svg" //电量 [75,100)
import dl100 from "@/common/img/command_flight/head/dl100.svg" //电量 100
import dl_charge from "@/common/img/command_flight/head/dl_charge.svg" //充电中

import sdr0 from "@/common/img/command_flight/head/sdr0.svg" //SDR信号  [0,15)   
import sdr15 from "@/common/img/command_flight/head/sdr15.svg" //SDR信号  [15,35)  
import sdr35 from "@/common/img/command_flight/head/sdr35.svg" //SDR信号  [35,55)  
import sdr55 from "@/common/img/command_flight/head/sdr55.svg" //SDR信号  [55,75)  
import sdr75 from "@/common/img/command_flight/head/sdr75.svg" //SDR信号  [75,95)  
import sdr95 from "@/common/img/command_flight/head/sdr95.svg" //SDR信号  [95,100)

import t_wrj from "@/common/img/command_flight/head/t_wrj.svg" //已链接上无人机
import f_wrj from "@/common/img/command_flight/head/f_wrj.svg" //未链接上无人机

import t_jc from "@/common/img/command_flight/head/t_jc.svg" //地图上的机场

import rtk from "@/common/img/command_flight/uav/uav_info/rtk.svg" // rtk数量
import gps from "@/common/img/command_flight/uav/uav_info/gps.svg" // gps数量
import dj from "@/common/img/command_flight/uav/uav_info/dj.svg" // 东经
import bw from "@/common/img/command_flight/uav/uav_info/bw.svg" // 北纬

function AirportTypeInfo (list) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const { token: { colorBgContainer, colorText }, } = theme.useToken(); //获取主题颜色

  const [loading, setLoading] = useState(false)//加载中···
  const UAVData = list.UAVData//无人机数据
  const airportData = list.airportData//机场数据

  const [isShowAirPortInfo, setIsShowAirPortInfo] = useState(false)//是否展开机场详情

  useEffect(() => {

    // eslint-disable-next-line
  }, [])

  return (
    <div
      className='h40 wid100 pdRL16'
      style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.6),rgba(0,0,0,0))' }}
    >
      <div className='flex jcsb align_center hei100'>
        <>{/* 左侧信息栏 */}
          <div className='flex jcc align_center'>
            <>{/* 返航高度 */}
              <Tooltip title='无人机返航高度'>
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='返航高度' src={fhgd} />
                  <span style={{ color: colorText }}>{Number(UAVData?.rth_altitude || 0).toFixed(1)} m</span>
                </span>
              </Tooltip>
            </>

            <>{/* 天气 */}
              <Tooltip title='机场天气'>
                <span>
                  <img
                    alt='天气'
                    draggable='false'
                    src={airportData?.rainfall === 1 ? xy : airportData?.rainfall === 2 ? zy : dy}
                    style={{ display: airportData?.rainfall > 0 && airportData?.rainfall < 65535 ? `` : `none` }}
                  />
                </span>
              </Tooltip>
            </>

            <>{/* 风速 */}
              <Tooltip title='环境风速'>
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='风速' src={fs} />
                  <span style={{ color: colorText }}>{airportData?.wind_speed} m/s</span>
                </span>
              </Tooltip>
            </>

            <>{/* 温度 */}
              <Tooltip title='环境温度'>
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='温度' src={wd} />
                  <span style={{ color: colorText }}>{airportData?.environment_temperature} ℃</span>
                </span>
              </Tooltip>
            </>

            <>{/* 湿度 */}
              <Tooltip title='环境湿度'>
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='湿度' src={sd} />
                  <span style={{ color: colorText }}>{airportData?.humidity}</span>
                </span>
              </Tooltip>
            </>
          </div>
        </>


        <>{/* 右侧信息栏 */}
          <div className='flex jcc align_center'>
            <>{/* 无人机链接情况 */}
              <Tooltip title={airportData?.mode_code !== 14 ? '无人机已连接' : '无人机未连接'}>
                <img
                  className="marL12"
                  draggable='false'
                  alt='无人机'
                  src={airportData?.mode_code !== 14 ? t_wrj : f_wrj}
                />
              </Tooltip>
            </>

            <>{/* SDR信号 */}
              <Tooltip title={`SDR信号：${airportData?.wireless_link_sdr_quality}`}>
                <img
                  className="marL12"
                  draggable='false'
                  alt='SDR'
                  src={
                    airportData?.wireless_link_sdr_quality === 0
                      ? sdr0
                      : airportData?.wireless_link_sdr_quality === 1
                        ? sdr15
                        : airportData?.wireless_link_sdr_quality === 2
                          ? sdr35
                          : airportData?.wireless_link_sdr_quality === 3
                            ? sdr55
                            : airportData?.wireless_link_sdr_quality === 4
                              ? sdr75
                              : sdr95
                  }
                />
              </Tooltip>
            </>


            <>{/* 网络 1:4G| 2:以太网 */}
              {
                airportData?.network_state_type === 1//4G
                  ? (
                    <>
                      <Tooltip title={`${airportData?.network_state_rate}KB/s`}>
                        <img
                          className="marL12"
                          style={{ display: airportData?.wireless_link_4g_link_state ? `` : `none` }}
                          draggable='false'
                          alt='4g'
                          src={
                            airportData?.wireless_link_4g_gnd_quality < 2
                              ? cell0
                              : airportData?.wireless_link_4g_gnd_quality < 4
                                ? cell15
                                : airportData?.wireless_link_4g_gnd_quality < 6
                                  ? cell35
                                  : airportData?.wireless_link_4g_gnd_quality < 8
                                    ? cell55
                                    : airportData?.wireless_link_4g_gnd_quality < 9
                                      ? cell75
                                      : cell95
                          }
                        />
                      </Tooltip>
                    </>
                  )
                  : airportData?.network_state_type === 2//以太网
                    ? (
                      <>
                        <Tooltip title={`${airportData?.network_state_rate}KB/s`}>
                          <img
                            style={{ display: airportData?.network_state_type === 2 ? `` : `none` }}
                            className="marL12"
                            draggable='false'
                            alt='以太网'
                            src={Ethernet}
                          />
                        </Tooltip>
                      </>
                    )
                    : <></>
              }
            </>

            <>{/* 当前电量 */}
              <Tooltip
                title={
                  airportData?.drone_charge_state_state
                    ? `充电中(${airportData?.drone_charge_state_capacity_percent}%)···`
                    : `${airportData?.drone_charge_state_capacity_percent}%`}
              >
                <div className='marL12'>
                  <img
                    draggable='false'
                    alt='电量'
                    src={
                      airportData?.drone_charge_state_state
                        ? dl_charge
                        : airportData?.drone_charge_state_capacity_percent < 11
                          ? dl0
                          : airportData?.drone_charge_state_capacity_percent < 26
                            ? dl25
                            : airportData?.drone_charge_state_capacity_percent < 51
                              ? dl50
                              : airportData?.drone_charge_state_capacity_percent < 76
                                ? dl75
                                : airportData?.drone_charge_state_capacity_percent < 101
                                  ? dl100
                                  : dl_charge
                    }
                  />
                </div>
              </Tooltip>
            </>

            <>{/* 机场信息 */}
              <Tooltip title='机场详细信息'>
                <img
                  className='pointer marL12'
                  draggable='false'
                  alt='机场'
                  src={t_jc}
                  onClick={() => { setIsShowAirPortInfo(!isShowAirPortInfo) }}
                />
              </Tooltip>
            </>

            <>{/* 机场详细信息 */}
              {
                isShowAirPortInfo &&
                <div className='pos_abs pdR16 flex_col' style={{ top: 40, right: 0, zIndex: 1 }}>
                  <div
                    className='pos_abs w224 radius8 pd8 pos_rel'
                    style={{
                      top: '0', right: '0',
                      backgroundColor: 'rgba(0,0,0,0.7)',
                    }}>
                    <div>{airportData?.sn || `机场信息`} </div>
                    <Row>
                      {/* rtk数量 */}
                      <Col span={12} className='flex align_center'>
                        <span className="marR8">
                          <Tooltip title='rtk数量'>
                            <img draggable='false' src={rtk} alt='rtk数量' />
                          </Tooltip>
                        </span>
                        <span>
                          {airportData?.position_state_rtk_number}
                        </span>
                      </Col>

                      {/* gps数量 */}
                      <Col span={12} className='flex align_center'>
                        <span className="marR8">
                          <Tooltip title='gps数量'>
                            <img draggable='false' src={gps} alt='gps数量' />
                          </Tooltip>
                        </span>
                        <span>
                          {airportData?.position_state_gps_number}
                        </span>
                      </Col>


                      {/* 温度 */}
                      <Col span={12} className='flex align_center'>
                        <span className="marR8">
                          <Tooltip title='温度'>
                            <img className='h20 w20' draggable='false' src={wd} alt='温度' />
                          </Tooltip>
                        </span>
                        <span>{airportData?.temperature}℃</span>
                      </Col>

                      {/* 湿度 */}
                      <Col span={12} className='flex align_center'>
                        <span className="marR8 ">
                          <Tooltip title='湿度'>
                            <img className='h20 w20' draggable='false' src={sd} alt='湿度' />
                          </Tooltip>
                        </span>
                        <span>{airportData?.humidity}</span>
                      </Col>


                      <Col span={12} className='flex align_center'>
                        <span className="marR8">
                          <Tooltip title='东经'>
                            <img draggable='false' src={dj} alt='东经' />
                          </Tooltip>
                        </span>
                        <span>{Number(airportData?.latitude || 0).toFixed(6)}</span>
                      </Col>

                      <Col span={12} className='flex align_center'>
                        <span className="marR8">
                          <Tooltip title='北纬'>
                            <img draggable='false' src={bw} alt='北纬' />
                          </Tooltip>
                        </span>
                        <span>{Number(airportData?.longitude || 0).toFixed(6)}</span>
                      </Col>
                    </Row>
                  </div>
                </div>
              }
            </>

          </div>
        </>
      </div>
    </div>
  )
}
export default AirportTypeInfo;